<template>
  <div class="header-controls" id="header__controls">
    <b-modal centered hide-footer id="feedbackModal" title="Send Feedback">
      <FeedbackModal ref="refFeedbackModal" />
    </b-modal>
    <b-modal centered hide-footer v-model="showSocialMediaExportModal" id="socialMediaExportModal" title="Creating Social Media Export">

      <div style="text-align:center">
      	<b-spinner v-if="isLoadingExport" label="Loading"></b-spinner>
      	<div v-if="!isLoadingExport">
      	<a class="btn btn-primary" v-if="downloadLink" :href="downloadLink" @click="showSocialMediaExportModal = false;">Download</a>
      	</div>
      </div>
    </b-modal>
    <b-modal centered hide-footer hide-backdrop  no-close-on-backdrop  v-model="showSocialMediaImportModal" content-class="shadow" id="socialMediaImportModal" title="Import Social Media Posts">
    	<p><a href="/assets/import-social-media.xlsx" target="_blank">Download example .xlsx file</a></p>
    	<VueFilePond
    	    name="file"
    	    ref="importPond"
    	    label-idle="Upload .xlsx"
    	    :allow-multiple="true"
    	    :dropOnElement="true"
    	    :dropOnPage="false"
    	    :allowRevert="false"
    	    v-bind:files="filepond"
    	    v-on:init="handleFilePondInit"
    	    credits="false"
    	  />
	   	  <div class="imported-results" v-show="loadedImportResults">
	   	  	<b-button v-b-toggle.collapse-import-results variant="text">
	   	  		<i v-show="!expandImportResults" class="fas fa-chevron-down collapse-indicator"></i>
	   	  		<i v-show="expandImportResults" class="fas fa-chevron-right collapse-indicator"></i>
	   	  	  <strong style="color:var(--error--color--border)" v-if="importedResults.errors.length > 0">ERROR: {{importedResults.errors.length}} row(s) have problems.</strong>
	   	  	  <strong>{{importedResults.imported.length}} posts imported.</strong>
	   	  	  <strong>{{importedResults.total}} data rows in file.</strong>
	   	  	  <strong>Click to view details.</strong>
	   	  	  <br/>
	   	  	</b-button>
	   	  	<b-collapse id="collapse-import-results" v-model="expandImportResults">
	   	  	  <div class="collapse-inner">

	   	  	  	<ol v-if="importedResults.errors.length > 0" >
	   	  	  		<li :class="`{e.new ? 'imported-new':'imported-existing'}`" v-for="(e, indexe) in importedResults.errors" >
	   	  	  			<span class='imported-title'>{{e.title}}</span>
	   	  	  			<span class='imported-publish_date' v-if="e.publish_date != null">{{e.publish_date | moment("MMM D,YYYY HH:mm a")}}</span>
	   	  	  			<span class='imported-publish_date' v-if="e.publish_date == null">No Date Set</span>
	   	  	  			<span class='imported-social_campaign' v-if="e.social_campaign">Campaign: {{e.social_campaign.title}}</span>
	   	  	  			<span class='imported-social_series' v-if="e.social_series">Series: {{e.social_series.title}}</span>
	   	  	  				   	  	  			<span :class="getImportStatusClass(e.status)">Row {{e.row}}; {{e.status.name}}</span>
	   	  	  		</li>
	   	  	  	</ol>

					<ol v-if="importedResults.imported.length > 0" >
						<li :class="`{s.new ? 'imported-new':'imported-existing'}`" v-for="(s, index) in importedResults.imported" >
							<span class='imported-title'> <a @click="showEditDeliverableModal(s)">{{s.title}}</a></span>
							<span class='imported-publish_date' v-if="s.publish_date != null">{{s.publish_date | moment("MMM D,YYYY HH:mm a")}}</span>
							<span class='imported-publish_date' v-if="s.publish_date == null">No Date Set</span>

							<span class='imported-social_campaign' v-if="s.social_campaign">Campaign: {{s.social_campaign.title}}</span>
							<span class='imported-social_series' v-if="s.social_series">Series: {{s.social_series.title}}</span>

							<span :class="getImportStatusClass(s.status)">Row {{s.row}}; {{s.status.name}}</span>
						</li>
					</ol>
	   	  	  </div>
	   	  	</b-collapse>
				</div>

    </b-modal>

    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-7 col-md-8 col-8 left-side">
          <div class="form-inline" v-if="$router.currentRoute.name == 'globalAlert'">
            <b-button
              class="header-filter-btns"
              variant="theme"
              @click="$emit('createNewAlert')"
            >
              Add Alert
              <i class="fas text-primary fa-plus fa-fw"></i>
            </b-button>
          </div>
          <div :class="`form-inline ${$router.currentRoute.name == 'dashboard' || $router.currentRoute.name == 'myWeek' ? 'deliverable-filter-form' : ''}`" v-if="$router.currentRoute.name != 'permissionManager' && $router.currentRoute.name != 'globalAlert' && $router.currentRoute.name != 'userGlobalAlert'">
            <div class="input-group top-search">
              <input
                type="text"
                class="form-control"
                :class="$router.currentRoute.name == 'globalSearch' ? '' : 'media-calls-search'"
                v-model="searchQuery"
                v-debounce:500ms="setQuery"
                :debounce-events="['keyup']"
                :placeholder="querySearchPlaceHolder"
                @click="$refs.searchQuery.select()"
                @keypress.enter="triggerSearch"
                ref="searchQuery"
                id="search-query"
              />
              <div class="input-group-append cursor-pointer" @click="triggerSearch">
                <span class="input-group-text">
                  <i class="fas fa-search"></i>
                </span>
              </div>
            </div>
            <b-button
              ref="filterBoxBtn"
              id="popover-button-event"
              class="ml-2 mr-2 header-filter-btns"
              variant="theme"
              tabindex="0"
              href="#"
              v-if="$router.currentRoute.name != 'globalSearch'"
              @keydown.esc="$refs.popover.$emit('close')"
            >
              <span :class="{'wider-filter-only': $router.currentRoute.name == 'dashboard' || $router.currentRoute.name == 'myWeek'}">Filter</span>
              <img src="@/csmworkflow/img/filter.svg" />
            </b-button>
            <b-popover
              triggers="click blur"
              boundary="window"
              placement="bottom"
              ref="popover"
              target="popover-button-event"
              custom-class="deliverable-filter"
            >
              <div class="d-flex flex-row">
                <div class="filter-item item__status">
                  <label>Post Status</label>
                  <div v-if="!isMobile()" class="status-wrap">
                    <a
                      href="#"
                      @click="setPublishStatusFilter(s)"
                      class="badge mr-2"
                      :style="{color: 'var(--wf-secondary)', backgroundColor: s.color}"
                      v-for="(s, index) in publishStatuses"
                      :key="index"
                    >{{ s.name }}</a>
                  </div>
                  <div class="custom-field status-field">
                    <multiselect
                      v-if="isMobile()"
                      :searchable="true"
                      v-model="filterQuery.publishStatus"
                      label="name"
                      :options="publishStatuses"
                      placeholder="Select post status"
                      :show-labels="false"
                      :multiple="true"
                      :hide-selected="true"
                    >
                      <template slot="option" slot-scope="props">
                        <div
                          :style="{ color: 'var(--wf-secondary)', borderRadius: '10px', backgroundColor: props.option.color, height: '40px', lineHeight: '40px', textAlign: 'center' }"
                        >{{ props.option.name }}</div>
                      </template>
                      <template slot="tag" slot-scope="props">
                        <div
                          :style="{ color: 'var(--wf-secondary)', borderRadius: '10px', backgroundColor: props.option.color, textAlign: 'center', display: 'inline-block', padding: '5px 10px', marginRight: '5px' }"
                        >{{ props.option.name }}</div>
                      </template>
                    </multiselect>
                  </div>
                </div>
                <div class="grouped-filter-item">

                  <div class="filter-item item__coordinator">
                    <label>Assigned To</label>
                    <div class="coordinator-wrap">
                      <multiselect
                        ref="coordinatorFilter"
                        v-model="filterQuery.coordinator"
                        :options="allActiveUsers"
                        :show-labels="false"
                        :multiple="true"
                        open-direction="bottom"
                        label="name"
                        track-by="id"
                        :hideSelected="false"
                        :hide-selected="false"
                        :close-on-select="false"
                        :clear-on-select="false"
                      >
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                          <span
                            class="multiselect__single"
                            v-if="values.length && !isOpen"
                          >{{ values.length }} options selected</span>
                        </template>
                      </multiselect>
                    </div>
                  </div>
                
                  <div class="filter-item item__social_network" v-if="checkCalendarMode(['deliverables', 'tasks'])">
                    <label>Social Network</label>
                    <div class="social-network-wrap">
                      <multiselect
                        ref="socialNetworkFilter"
                        v-model="filterQuery.socialNetwork"
                        :options="systemSettings.social_networks || []"
                        :show-labels="false"
                        :multiple="true"
                        open-direction="bottom"
                        label="network_name"
                        track-by="id"
                        :hideSelected="false"
                        :hide-selected="false"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :loading="!systemSettings.social_networks"
                      >
                      <template slot="option" slot-scope="props">
                        <div><i :class="`fab fa-`+`getSocialNetworkClass(${props.option.api_type})`"></i> {{ props.option.network_name }}</div>
                      </template>
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                          <span
                            class="multiselect__single"
                            v-if="values.length && !isOpen"
                          >{{ values.length }} options selected</span>
                        </template>
                      </multiselect>
                    </div>
                  </div>

                </div>

                <div class="grouped-filter-item">

                  <div class="filter-item item__tag" v-if="checkCalendarMode(['deliverables', 'tasks'])">
                    <label>Tag</label>
                    <div class="tag-wrap">
                      <multiselect
                        ref="tagFilter"
                        v-model="filterQuery.tag"
                        :options="tags"
                        :show-labels="false"
                        :multiple="true"
                        open-direction="bottom"
                        label="name"
                        track-by="id"
                        :hideSelected="false"
                        :hide-selected="false"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :loading="isTagsLoading"
                        :preserve-search="true"
                        @search-change="onTagSearch"
                      >
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                          <span
                            class="multiselect__single"
                            v-if="values.length && !isOpen"
                          >{{ values.length }} options selected</span>
                        </template>
                        <template slot="noOptions">Start typing to find tags.</template>

                        <template slot="noResult">No results. Please try changing the search query.</template>
                      </multiselect>
                    </div>
                  </div>

                  <div class="filter-item item__department">
                    <div>
                      <label>Department</label>
                      <b-form-checkbox
                        v-if="isMobile()"
                        class="float-right csm-checkbox"
                        v-model="filterQuery.noDepartment"
                        id="no-department"
                        name="no-department"
                        value="accepted"
                        unchecked-value="not_accepted"
                        @input="filterQuery.noDepartment == 'accepted' ? filterQuery.department = [] : ''"
                      >No Department</b-form-checkbox>
                    </div>
                    <div class="tag-wrap">
                      <multiselect
                        ref="departmentFilter"
                        v-model="filterQuery.department"
                        open-direction="bottom"
                        label="name"
                        track-by="id"
                        :options="allActiveDepartments"
                        :hideSelected="false"
                        :hide-selected="false"
                        :show-labels="false"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        @select="filterQuery.noDepartment = 'not_accepted'"
                      >
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                          <span
                            class="multiselect__single"
                            v-if="values.length && !isOpen"
                          >{{ values.length }} options selected</span>
                        </template>
                        <template slot="noOptions">Start typing to find departments.</template>

                        <template slot="noResult">No results. Please try changing the search query.</template>
                      </multiselect>
                    </div>
                    <b-form-checkbox
                      v-if="!isMobile()"
                      class="mt-2 csm-checkbox"
                      v-model="filterQuery.noDepartment"
                      id="no-department"
                      name="no-department"
                      value="accepted"
                      unchecked-value="not_accepted"
                      @input="filterQuery.noDepartment == 'accepted' ? filterQuery.department = [] : ''"
                    >No Department</b-form-checkbox>
                  </div>
                
                </div>

                <div class="filter-item item__date" :class="{'filter-item-no-border': $router.currentRoute.name == 'calendar'}">
                  <div class="due__created__dates">

                    <div>
                      <label class="mt-2">Created</label>
                      <br />
                      <date-range-picker
                        ref="pickerDateCreated"
                        @update="onUpdateDateCreated"
                        :autoApply="true"
                        :ranges="customCreatedDateRanges"
                        v-model="filterQuery.dateCreatedRange"
                      ></date-range-picker>
                    </div>

                    <div v-if="checkCalendarMode(['deliverables', 'tasks'])">
                      <label class="mt-lg-2">Post Date</label>
                      <br />
                      <date-range-picker
                        ref="pickerPublishDate"
                        @update="onUpdatePublishDate"
                        :autoApply="true"
                        :ranges="customPublishDateRanges"
                        v-model="filterQuery.datePublishRange"
                      ></date-range-picker>
                    </div>
                  </div>
                </div>

                <div>
                  <div class="item__reset">
                    <b-button variant="theme" title="Reset All Filter" size="sm" @click="resetFilter"><i class="fas fa-undo"></i></b-button>
                    <b-button class="d-block d-lg-none" variant="theme" title="Close Filter Popup" size="sm" @click="$refs.popover.$emit('close')"><i class="fas fa-times"></i></b-button>
                  </div>
                </div>
              </div>
              <div
                class="d-none d-md-block mt-3"
                v-if="isFilterActive()"
              >
                <label>Click to remove filters :</label>
                <br />
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="filterQuery.query = null; searchQuery = ''"
                  :style="{cursor: 'pointer'}"
                >{{ filterQuery.query }}</span>
                <span
                  class="badge mr-2 mb-2"
                  @click="removeFilter(publishStatus)"
                  :style="{cursor: 'pointer', color: 'var(--wf-secondary)', backgroundColor: publishStatus.color}"
                  v-for="publishStatus in filterQuery.publishStatus"
                >{{ publishStatus.name }}</span>
                <span
                  class="badge mr-2 mb-2 bg-primary cursor-pointer"
                  @click="removeFilter(socialNetwork)"
                  style="color: var(--wf-secondary);"
                  v-for="socialNetwork in filterQuery.socialNetwork"
                ><i :class="`fab fa-`+`getSocialNetworkClass(${socialNetwork.api_type})`"></i> {{ socialNetwork.network_name }}</span>

                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter(coordinator)"
                  :style="{cursor: 'pointer'}"
                  v-for="coordinator in filterQuery.coordinator"
                >{{ coordinator.name }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter('filterByDateCreated')"
                  :style="{cursor: 'pointer'}"
                  v-if="filterQuery.filterByDateCreated"
                >Created: {{ filterQuery.dateCreatedRange.startDate | moment('MMM DD') }} - {{ filterQuery.dateCreatedRange.endDate | moment('MMM DD') }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter('filterByPublishDate')"
                  :style="{cursor: 'pointer'}"
                  v-if="filterQuery.filterByPublishDate"
                >Date to Post: {{ filterQuery.datePublishRange.startDate | moment('MMM DD') }} - {{ filterQuery.datePublishRange.endDate | moment('MMM DD') }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter(tag)"
                  :style="{cursor: 'pointer'}"
                  v-for="tag in filterQuery.tag"
                >{{ tag.name }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter(socialSeries)"
                  :style="{cursor: 'pointer'}"
                  v-for="socialSeries in filterQuery.socialSeries"
                >{{ socialSeries.name }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter(socialCampaign)"
                  :style="{cursor: 'pointer'}"
                  v-for="socialCampaign in filterQuery.socialCampaign"
                >{{ socialCampaign.name }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter(department)"
                  :style="{cursor: 'pointer'}"
                  v-for="department in filterQuery.department"
                >{{ department.name }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter(project)"
                  :style="{cursor: 'pointer'}"
                  v-for="project in filterQuery.project"
                >{{ project.title }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="filterQuery.noDepartment='not_accepted'"
                  :style="{cursor: 'pointer'}"
                  v-if="filterQuery.noDepartment == 'accepted'"
                >No Department</span>
              </div>
            </b-popover>

            <div class="ml-2 calendar-type-control" v-if="$router.currentRoute.name == 'calendar'">
              <label class="btn-theme date-filter-triggers">
                <b-form-radio
                  ref="deliverables"
                  v-model="dataSetType"
                  class="csm-checkbox"
                  id="deliverables"
                  value="deliverables"
                  name="dataSetTypeTrigger"
                  @change="changeCalendarMode('deliverables')"
                >
                  Deliverables
                </b-form-radio>
              </label>
              <label class="btn-theme ml-2 date-filter-triggers">
                <b-form-radio
                  ref="tasks"
                  v-model="dataSetType"
                  class="csm-checkbox"
                  id="tasks"
                  value="tasks"
                  name="dataSetTypeTrigger"
                  @change="changeCalendarMode('tasks')"
                >
                  Tasks
                </b-form-radio>
              </label>
              <label class="btn-theme ml-2 date-filter-triggers">
                <b-form-radio
                  ref="projects"
                  v-model="dataSetType"
                  class="csm-checkbox"
                  id="projects"
                  value="projects"
                  name="dataSetTypeTrigger"
                  @change="changeCalendarMode('projects')"
                >
                  Projects
                </b-form-radio>
              </label>
            </div>

            <!-- Hardcoded -->
            <div class="new-deliverables mr-2" v-if="$router.currentRoute.name == 'mediaCallPage'">
              <button type="button" class="btn btn-theme header-filter-btns" @click="createDeliverableDropdownClick({id: 'media_call', name: 'Media Call'})">
                New Media Call <i class="fas text-primary float-right fa-plus fa-fw"></i>
              </button>
            </div>

            <!-- Hardcoded -->
            <div class="new-deliverables mr-2" v-if="$router.currentRoute.name == 'socialMedia' && getSystemSetting('social_media___show_new_post_button')">
              <button type="button" class="btn btn-theme header-filter-btns" @click="createDeliverableDropdownClick({id: 'social_media', name: 'Social Media'})">
                New Social Media Post <i class="fas text-primary float-right fa-plus fa-fw"></i>
              </button>
            </div>

            <div class="filter-item item__socialCampaigns mr-2" v-if="checkCalendarMode(['deliverables', 'tasks'])" style="max-width: 200px">
              <!-- <label>Social Campaign</label> -->
              <div class="socialCampaigns-wrap">
                <multiselect
                  ref="socialCampaignsFilter"
                  v-model="filterQuery.socialCampaign"
                  :options="socialCampaigns"
                  :show-labels="false"
                  :multiple="true"
                  open-direction="bottom"
                  label="name"
                  track-by="id"
                  :hideSelected="false"
                  :hide-selected="false"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :loading="isSocialCampaignsLoading"
                  :preserve-search="true"
                  placeholder="Social Campaign"
                  @search-change="onSocialCampaignSearch"
                >
                  <template slot="selection" slot-scope="{ values, search, isOpen }">
                    <span
                      class="multiselect__single"
                      v-if="values.length && !isOpen"
                    >{{ values.length }} options selected</span>
                  </template>
                  <template slot="noOptions">Start typing to find social campaign.</template>

                  <template slot="noResult">No results. Please try changing the search query.</template>
                </multiselect>
              </div>
            </div>

            <div class="filter-item item__socialSeries" v-if="checkCalendarMode(['deliverables', 'tasks'])">
              <!-- <label>Social Series</label> -->
              <div class="socialSeries-wrap">
                <multiselect
                  ref="socialSeriesFilter"
                  v-model="filterQuery.socialSeries"
                  :options="socialSeriesPlural"
                  :show-labels="false"
                  :multiple="true"
                  open-direction="bottom"
                  label="name"
                  track-by="id"
                  :hideSelected="false"
                  :hide-selected="false"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :loading="isSocialSeriesLoading"
                  :preserve-search="true"
                  placeholder="Multiple Date Posts"
                  @search-change="onSocialSeriesSearch"
                >
                  <template slot="selection" slot-scope="{ values, search, isOpen }">
                    <span
                      class="multiselect__single"
                      v-if="values.length && !isOpen"
                    >{{ values.length }} options selected</span>
                  </template>
                  <template slot="noOptions">Start typing to find social serices.</template>

                  <template slot="noResult">No results. Please try changing the search query.</template>
                </multiselect>
              </div>
            </div>

            <div
              v-if="$router.currentRoute.name != 'globalSearch' && $router.currentRoute.name != 'calendar'"
              class="ml-2 mobile-expand-ctrls cursor-pointer mobile-filter-only"
            >
              <b-button
                class="header-filter-btns expand-ctrls"
                variant="theme"
                @click="expandAll = !expandAll; toggleStatusView();"
              >
                <span class="icon" v-show="!expandAll"><i class="fas text-primary fa-expand fa-fw"></i></span>
                <span class="icon" v-show="expandAll"><i class="fas text-primary fa-compress fa-fw"></i></span>
              </b-button>
            </div>

            <div
              v-if="$router.currentRoute.name == 'myWeek' || $router.currentRoute.name == 'dashboard'"
              class="ml-2 mobile-views-section cursor-pointer mobile-filter-only"
            >
              <b-button
                class="header-view-btns"
                variant="theme"
                ref="MobileViewButton"
                id="MobileViewButton"
                v-b-modal.headerViewSelectModal
              >
                <span class="icon"><i class="fas fa-fw fa-eye text-primary"></i></span>
              </b-button>

            </div>

            <div
              v-if="$router.currentRoute.name == 'globalSearch'"
              class="btn-group add-new__global_search"
            >
              <b-button
                @keydown.esc="$refs.GSCreatedDatePopover.$emit('close')"
                class="ml-md-2 header-filter-btns"
                variant="theme"
                @click="GSCreatedDatePopover = !GSCreatedDatePopover"
                ref="GSCreatedDate"
                id="GSCreatedDate"
              >
                Created Date
                <i class="far fa-calendar-check text-primary"></i>
              </b-button>
              <b-popover
                ref="GSCreatedDatePopover"
                :show.sync="GSCreatedDatePopover"
                target="GSCreatedDate"
                triggers="click blur"
                placement="bottom"
                custom-class="filter_popover__gs created-date-popover"
              >
                <date-range-picker
                  ref="pickerDateCreated"
                  opens="inline"
                  @update="onUpdateDateCreated"
                  :autoApply="true"
                  :ranges="customCreatedDateRanges"
                  v-model="filterQuery.dateCreatedRange"
                ></date-range-picker>
              </b-popover>
            </div>
            <div
              v-if="$router.currentRoute.name == 'globalSearch' && (GSDataType == 'departments' || GSDataType == 'tags' || GSDataType == 'contacts' || GSDataType == 'coordinators')"
              class="btn-group add-new__global_search"
            >
              <div
                class="ml-md-2 toggle-dept-status cursor-pointer"
                @click="filterQuery.status[0] == 'Active' ? filterQuery.status = ['Archived'] : filterQuery.status = ['Active']"
              >
                <b-button
                  class="header-filter-btns"
                  :class="{'none-active-btn': filterQuery.status[0] != 'Active'}"
                  variant="theme"
                >
                  Active
                  <i class="fas fa-toggle-on text-primary float-right ml-2"></i>
                </b-button>
                <b-button
                  class="header-filter-btns"
                  :class="{'none-active-btn': filterQuery.status[0] != 'Archived'}"
                  variant="theme"
                >
                  Archived
                  <i class="fas fa-toggle-off text-primary float-right ml-2"></i>
                </b-button>
              </div>
            </div>
            <div
              v-if="$router.currentRoute.name == 'globalSearch' && (GSDataType == 'departments' || GSDataType == 'tags')"
              class="btn-group add-new__global_search sorting"
            >
              <button
                class="btn btn-theme ml-md-2 header-filter-btns dropdown-toggle"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Sort
                <i class="fas fa-sort text-primary float-right"></i>
              </button>
              <div class="dropdown-menu">
                <a class="dropdown-item" @click="setSort('usedDesc')" href="#">Frequency Decending</a>
                <a class="dropdown-item" @click="setSort('usedAsc')" href="#">Frequency Ascending</a>
              </div>
            </div>
            <div
              v-if="$router.currentRoute.name == 'globalSearch' && GSDataType == 'all'"
              class="btn-group add-new__global_search"
            >
              <b-button
                class="ml-md-2 header-filter-btns dropdown-toggle"
                variant="theme"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >Add</b-button>
              <div class="dropdown-menu">
                <a
                  v-if="userAbilities.createTag || userAbilities.editMediaCall"
                  class="dropdown-item"
                  @click="$emit('click', 'tag')"
                  href="#"
                >Add Tags</a>
                <a
                  v-if="userAbilities.createContact || userAbilities.editMediaCall"
                  class="dropdown-item"
                  @click="$emit('click', 'contact')"
                  href="#"
                >Add Contacts</a>
                <a
                  v-if="userAbilities.createUser"
                  class="dropdown-item"
                  @click="$emit('click', 'coordinator')"
                  href="#"
                >Add User</a>
                <a
                  v-if="userAbilities.createDepartment || userAbilities.editMediaCall"
                  class="dropdown-item"
                  @click="$emit('click', 'department')"
                  href="#"
                >Add Departments</a>
              </div>
            </div>
            <div
              v-if="$router.currentRoute.name == 'globalSearch' && GSDataType != 'all'"
              :class="!checkPermissions ? 'no-permission' : ''"
              class="btn-group add-new__global_search specific-btn"
            >
              <b-button
                v-if="checkPermissions"
                @click.prevent="$emit('click', GSDataType.substring(0, GSDataType.length - 1))"
                variant="theme"
                class="ml-md-2 header-filter-btns action"
              >
                Add
                <span style="text-transform: capitalize">{{ tabType }}</span>
              </b-button>
              <div class="btn-group">
                <button
                  type="button"
                  v-if="checkPermissions"
                  class="btn btn-theme dropdown-toggle options"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <b-button
                  class="ml-md-2 header-filter-btns dropdown-toggle"
                  v-if="!checkPermissions"
                  variant="theme"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >Add</b-button>
                <div class="dropdown-menu">
                  <a
                    v-if="GSDataType != 'tags' && (userAbilities.createTag || userAbilities.editMediaCall)"
                    class="dropdown-item"
                    @click="$emit('click', 'tag')"
                    href="#"
                  >Add Tags</a>
                  <a
                    v-if="GSDataType != 'contacts' && (userAbilities.createContact || userAbilities.editMediaCall)"
                    class="dropdown-item"
                    @click="$emit('click', 'contact')"
                    href="#"
                  >Add Contacts</a>
                  <a
                    v-if="GSDataType != 'coordinators' && userAbilities.createUser"
                    class="dropdown-item"
                    @click="$emit('click', 'coordinator')"
                    href="#"
                  >Add User</a>
                  <a
                    v-if="GSDataType != 'departments' && (userAbilities.createDepartment || userAbilities.editMediaCall)"
                    class="dropdown-item"
                    @click="$emit('click', 'department')"
                    href="#"
                  >Add Departments</a>
                </div>
              </div>
            </div>
            <div class="ml-2">
              <FeedbackBtn />
            </div>
          </div>
          <div
            class="mt-3 filter-badges"
            v-if="isFilterActive()"
          >
            <label class="remove-filter-text">Click to remove filters:</label>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="filterQuery.query = null; searchQuery = ''"
              :style="{cursor: 'pointer'}"
            >{{ filterQuery.query }}</span>

            <span
              class="badge mr-2 mb-2"
              @click="removeFilter(publishStatus)"
              :style="{cursor: 'pointer', color: 'var(--wf-secondary)', backgroundColor: publishStatus.color}"
              v-for="publishStatus in filterQuery.publishStatus"
            >{{ publishStatus.name }}</span>
            <span
              v-if="$router.currentRoute.name == 'globalSearch' && filterQuery.sort"
              class="badge mr-2 mb-2 bg-primary cursor-pointer"
              style="color: var(--wf-secondary);"
              @click="removeFilter('resetDepartTagSort')"
            >{{ filterQuery.sort == 'usedDesc' ? 'Frequency Descending' : 'Frequency Ascending' }}</span>
            <span
              class="badge mr-2 mb-2 bg-primary cursor-pointer"
              @click="removeFilter(socialNetwork)"
              style="color: var(--wf-secondary);"
              v-for="socialNetwork in filterQuery.socialNetwork"
            ><i :class="`fab fa-`+`getSocialNetworkClass(${socialNetwork.api_type})`"></i> {{ socialNetwork.network_name }}</span>

            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter(coordinator)"
              :style="{cursor: 'pointer'}"
              v-for="coordinator in filterQuery.coordinator"
            >{{ coordinator.name }}</span>

            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('filterByDateCreated')"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.filterByDateCreated"
            >Created: {{ filterQuery.dateCreatedRange.startDate | moment('MMM DD') }} - {{ filterQuery.dateCreatedRange.endDate | moment('MMM DD') }}</span>

            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('filterByPublishDate')"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.filterByPublishDate"
            >Date to Post: {{ filterQuery.datePublishRange.startDate | moment('MMM DD') }} - {{ filterQuery.datePublishRange.endDate | moment('MMM DD') }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter(tag)"
              :style="{cursor: 'pointer'}"
              v-for="tag in filterQuery.tag"
            >{{ tag.name }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter(socialSeries)"
              :style="{cursor: 'pointer'}"
              v-for="socialSeries in filterQuery.socialSeries"
            >{{ socialSeries.name }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter(socialCampaign)"
              :style="{cursor: 'pointer'}"
              v-for="socialCampaign in filterQuery.socialCampaign"
            >{{ socialCampaign.name }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter(department)"
              :style="{cursor: 'pointer'}"
              v-for="department in filterQuery.department"
            >{{ department.name }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter(project)"
              :style="{cursor: 'pointer'}"
              v-for="project in filterQuery.project"
            >{{ project.title }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="filterQuery.noDepartment='not_accepted'"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.noDepartment == 'accepted'"
            >No Department</span>
  
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('overdue')"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.weekFilterOptions.overdue"
            >overdue</span>
             <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('today')"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.weekFilterOptions.today"
            >today</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('thisWeek')"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.weekFilterOptions.thisWeek"
            >this week</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('nextWeek')"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.weekFilterOptions.nextWeek"
            >next week</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('upcoming')"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.weekFilterOptions.upcoming"
            >upcoming</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('noDeadline')"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.weekFilterOptions.noDeadline"
            >no deadline</span>

          </div>
        </div>
        <div class="col-sm-5 col-md-4 col-4 text-right right-side">
          <div class="logo-user">
            <HeaderNotification />
            <LoggedInUser />
            <Logo />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueFilePond from "vue-filepond";
const VueFilePond = vueFilePond();
import "filepond/dist/filepond.min.css";

import { mapActions, mapGetters, mapMutations } from "vuex";
import Logo from "./Logo";
import LoggedInUser from "./LoggedInUser";
import HeaderNotification from "./HeaderNotification";
import FeedbackBtn from "./FeedbackBtn";
import FeedbackModal from "./FeedbackModal";
import ViewTitleModal from "./ViewTitleModal";
import router from "../../routes";
import vueStarRate from "vue-js-star-rating";

export default {
  props: ["myWeek", "GSDataType", "namespace"],
  data() {
    return {
    	expandImportResults:false,
    	importedResults:{
    		imported:[],
    		errors:[],
    		total:0
    	},
    	loadedImportResults:false,
      filepond: [],
    	showSocialMediaExportModal: false,
    	showSocialMediaImportModal: false,
    	isLoadingImport:false,
    	isLoadingExport:false,
    	downloadError:null,
    	downloadLink:null,
    	importError:null,
      dataSetType: 'deliverables',
      reloadCounter:0,
      GSCreatedDatePopover: false,

      customCreatedDateRanges: {
        Yesterday: [
          this.$moment().subtract(1, "days").toDate(),
          this.$moment().subtract(1, "days").toDate(),
        ],
        "Last week": [
          this.$moment().subtract(7, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        "Last two week": [
          this.$moment().subtract(14, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        Today: [this.$moment().toDate(), this.$moment().toDate()],
        "This week": [
          this.$moment().startOf("week").toDate(),
          this.$moment().endOf("week").toDate(),
        ],
      },
      customCompletedDateRanges: {
        Yesterday: [
          this.$moment().subtract(1, "days").toDate(),
          this.$moment().subtract(1, "days").toDate(),
        ],
        "Last week": [
          this.$moment().subtract(7, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        "Last two week": [
          this.$moment().subtract(14, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        Today: [this.$moment().toDate(), this.$moment().toDate()],
        "This week": [
          this.$moment().startOf("week").toDate(),
          this.$moment().endOf("week").toDate(),
        ],
      },
      customPublishDateRanges: {
        Yesterday: [
          this.$moment().subtract(1, "days").toDate(),
          this.$moment().subtract(1, "days").toDate(),
        ],
        "Last week": [
          this.$moment().subtract(7, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        "Last two week": [
          this.$moment().subtract(14, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        Today: [this.$moment().toDate(), this.$moment().toDate()],
        "This week": [
          this.$moment().startOf("week").toDate(),
          this.$moment().endOf("week").toDate(),
        ],
      },
      searchQuery: "",
      isContactsLoading: false,
      isTagsLoading: false,
      isSocialSeriesLoading: false,
      isSocialCampaignsLoading: false,
      isDepartmentsLoading: false,
      contacts: [],
      tags: [],
      socialSeriesPlural: [], // Does this look wrong? Yes but how else do I differentiate plural and singular like tags/tag socialCampaigns/socialCampaign? Well if you don't like it than change it idc.
      socialCampaigns: [],
      departments: [],
      showUserSelect: false,
      expandAll: !this.isMobile(),
      filterQuery: {
        sort: "",
        query: "",
        dateCreatedRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        datePublishRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        status: [],
        publishStatus: [],
        socialNetwork: [],
        tag: [],
        socialSeries: [], 
        socialCampaign: [],
        department: [],
        coordinator: [],
        project: [],
        noDepartment: "not_accepted",
        weekFilterOptions: {
            overdue: false,
            today: false,
            thisWeek: false,
            nextWeek: false,
            upcoming: false,
            noDeadline: false,
        }
      },
      calendarMode: 'deliverables',
    };
  },
  components: {
    VueFilePond,
    Logo,
    vueStarRate,
    HeaderNotification,
    LoggedInUser,
    FeedbackBtn,
    FeedbackModal,
    ViewTitleModal,
  },
  computed: {
    ...mapGetters([
      "deliverableTypes",
      "deliverablePublishStatus",
      "allCustomFields",
      "allUsers",
      "allActiveUsers",
      "allDepartments",
      "allActiveDepartments",
      "allContacts",
      "allActiveContacts",
      "allTags",
      "allSocialSeries",
      "allSocialCampaigns",
      // "deliverableFilter",
      "socialMediaFilter",
      "myWeekDeliverableFilter",
      "mediaCallFilter",
      "calendarFilter",
      "globalSearchFilter",
      "initialContacts",
      "initialTags",
      "initialDepartments",
      "userAbilities",
      "GSRecentSearch",
      "userViews",
      "allProjects",
      "systemSettings",
      "socialGroupBy",
      "getSystemSetting"
    ]),
    querySearchPlaceHolder() {
      if(this.$router.currentRoute.name == 'globalSearch') {
        return 'Global search...'
      } else if(this.$router.currentRoute.name == 'calendar') {
        return 'Search...'
      } else {
        return 'Search...'
      }
    },
    statuses() {
      let statusField = undefined;
      if (this.calendarMode == 'deliverables' || this.calendarMode == 'tasks') {
        statusField = _.find(this.allCustomFields, { field_key: "status" });
      } else if (this.calendarMode == 'projects') {
        statusField = _.find(this.allCustomFields, { field_key: "project_status" });
      }
      if (typeof statusField != "undefined") {
        let valueSet = [],
          data = JSON.parse(statusField.value_set);
        Object.keys(data).forEach(function (item) {
          valueSet.push(data[item]);
        });
        return valueSet;
      }
    },
    publishStatuses() {
      if(this.systemSettings.publish_statuses){
        return this.systemSettings.publish_statuses;
      }
      return [];
    },
    checkPermissions() {
      switch (this.GSDataType) {
        case "tags":
          return (
            this.userAbilities.createTag || this.userAbilities.editMediaCall
          );
        case "contacts":
          return (
            this.userAbilities.createContact || this.userAbilities.editMediaCall
          );
        case "coordinators":
          return this.userAbilities.createUser;
        case "departments":
          return (
            this.userAbilities.createDepartment ||
            this.userAbilities.editMediaCall
          );
      }
    },
    tabType() {
      return typeof this.GSDataType != "undefined" ? this.GSDataType : "";
    },
    isCalendarView() {
      return this.$router.currentRoute.name == 'calendar';
    },
    apiUrl() {
      return process.env.MIX_API_BASE_URL;
    },
  },
  mounted() {
    let self = this

    if(this.calendarFilter.dataSetType) {
      this.dataSetType = this.calendarFilter.dataSetType;
    }
    if(self.allProjects.length == 0) {
      self.fetchAllProjects()
    }
    
    this.initSocialSeries();
    this.initSocialCampaigns();

    // Changed this because create deliverable is a split button so we need an inital type
    this.initDeliverableTypes()
    // hiding the header logo when scrolling in mobile
    if(this.isMobile() && this.$store.getters.isLoggedIn) {

      $('html').removeClass('is__safari');
      var prevScrollpos = window.pageYOffset;
      window.onscroll = function() {
        var currentScrollPos = window.pageYOffset;
        if (prevScrollpos > currentScrollPos) {
          document.getElementById("header__controls").style.top = "0";
        } else {
          document.getElementById("header__controls").style.top = "-60px";
        }
        prevScrollpos = currentScrollPos;
      }
    }

    this.$root.$on('bv::popover::show', bvEventObj => {
      $('body').addClass('popover-shown');
    });
    this.$root.$on('bv::popover::hide', bvEventObj => {
      $('body').removeClass('popover-shown');
    });
    this.$root.$on('setSaveView', () => {
			this.loadView();
		});
		this.$root.$on('resetFilter', () => {
			this.resetFilter();
		});

		this.$root.$on('exportSocialMediaExcel', (customFilter) => {
			let that = this;
				this.showSocialMediaExportModal = true;
				this.isLoadingExport = true;
				this.downloadError = "";

				if (customFilter) {
				} else {
					customFilter = self.filterQuery;
				}

				this.startDownloadDeliverableExcel(customFilter).then(function(response) {
					if (response.data.token != "") {
							that.downloadLink = process.env.MIX_API_BASE_URL + "downloadFile/" + response.data.token;
					} else {
							that.downloadLink = "";
							that.downloadError = "Invalid download token returned from server.";
					}
					that.isLoadingExport = false;
				});
		});


		this.$root.$on('importSocialMediaExcel', () => {
				let that = this;
				this.showSocialMediaImportModal = true;
				this.isLoadingImport = true;
				this.uploadError = "";

		});





    this.$root.$on('filterQueryUpdate', (eventObj) => {
      self.filterQuery.listByPublishDate = eventObj.currentFilter.listByPublishDate;
      self.filterQuery.datePublishRange = eventObj.currentFilter.datePublishRange;
      self.filterQuery.listByPublishDate = eventObj.currentFilter.listByPublishDate;
      self.filterQuery.listDatePublishRange = eventObj.currentFilter.listDatePublishRange;

      if (typeof eventObj.currentFilter.listByDateRange != "undefined") {
    	  self.filterQuery.listByDate = eventObj.currentFilter.listByDate;
    	  self.filterQuery.listByDateRange = eventObj.currentFilter.listByDateRange;
    	}
      if (typeof eventObj.currentFilter.listByDateField != "undefined") {
    	  self.filterQuery.listByDateField = eventObj.currentFilter.listByDateField;
    	}
      self.reloadCounter++;
    });

    // Used for when the calendar set the view for publish status
    this.$root.$on('calendarSetView', () => {
      // this.filterQuery = this.$store.getters.deliverableFilter;
      this.filterQuery = this.$store.getters.socialMediaFilter;
    });

    this.onWhoSearch("");
    this.onTagSearch("");
    this.onDepartmentSearch("");
    // if (router.currentRoute.name == "myWeek") {
    //   this.filterQuery = this.myWeekDeliverableFilter;
    // } else if (router.currentRoute.name == "dashboard") {
    //   this.filterQuery = this.deliverableFilter;
    // } else if (router.currentRoute.name == "mediaCallPage") {
    //   this.filterQuery = this.mediaCallFilter;
    // } else if (router.currentRoute.name == "calendar") {
    //   this.filterQuery = this.calendarFilter;
    // } else if (router.currentRoute.name == "globalSearch") {
    //   this.globalSearchFilter.status = [];
    //   this.globalSearchFilter.sort = '';
    //   this.filterQuery = this.globalSearchFilter;
    // }

    this.filterQuery = this.socialMediaFilter;


    if (!this.filterQuery.filterByDateCreated) {
      this.filterQuery.dateCreatedRange = {
        startDate: new Date(),
        endDate: new Date(),
      };
    }

    if (!this.filterQuery.filterByPublishDate) {
      this.filterQuery.datePublishRange = {
        startDate: new Date(),
        endDate: new Date(),
      };
    }
  },
  methods: {
    ...mapActions([
    	'getSocialNetworkClass',
      'getDeliverableTypes',
      'getCalendarData',
      'fetchAllProjects',
      'fetchSocialSeries',
      'fetchSocialCampaigns',
      'startDownloadDeliverableExcel'
    ]),
    ...mapMutations([
      'setDataLoading',
      'setSocialGroupBy'
    ]),

    getImportStatusClass(status) {
    	let css = "imported-status ";
    	return css + "imported-status-"+status.slug;
  	},

      // Resource upload file
    handleFilePondInit() {
      this.$refs.importPond._pond.setOptions({
        server: {
						headers: {
							Authorization: "Bearer " + this.$store.getters.authToken
						},
						process: {
							method: 'POST',
							url: `${this.apiUrl}importSocialMedia`,
							withCredentials: true,
              ondata: this.handleFilePondSubmit,
              onload: this.handleFilePondSuccess,
          },
        }
      });
    },
    handleFilePondSubmit(data) {
    	this.isLoadingImport = true;
    	this.loadedImportResults = false;
    	this.importedResults = {
    		imported:[],
    		errors:[]
    	};

      return data;
    },
    handleFilePondSuccess(response, file) {
    	this.importedResults = JSON.parse(response);
    	for (var x = 0; x < 10; x++) {
    		for (var y = 0; y < this.importedResults.length; y++) {
    			this.importedResults.imported.push(this.importedResults.imported[$y]);
    		}
    		if (this.importedResults.imported.length > 20) {
    			break;
    		}
    	}
    	this.isLoadingImport = false;
    	this.loadedImportResults = true;
    	if (file) {
	    	this.$nextTick(() => {
	    	    this.$refs.importPond.removeFile(file.id);
	    	});
	    }

    },

		showEditDeliverableModal(d) {
			let openId = d.id;
			if (d.social_series) {
				if (d.social_series.master_deliverable_id != d.id) {
					openId = d.social_series.master_deliverable_id;
				}
			}

			this.$emit("showEditDeliverableModal", openId, 0);
		},

    isFilterActive() {
         if (router.currentRoute.name == "myWeek") {
           return (
            this.filterQuery.noDepartment == 'accepted' 
            || this.filterQuery.filterNoDueDate
            || this.filterQuery.query
            || this.filterQuery.status.length
            || this.filterQuery.publishStatus.length
            || this.filterQuery.filterByDateCreated
            || this.filterQuery.filterByDateCompleted
            || this.filterQuery.filterByPublishDate
            || this.filterQuery.coordinator.length 
            || this.filterQuery.tag.length
            || this.filterQuery.socialSeries.length
            || this.filterQuery.socialCampaign.length
            || this.filterQuery.department.length
            || this.filterQuery.sort
            || this.filterQuery.project.length
            || this.filterQuery.weekFilterOptions.overdue
            || this.filterQuery.weekFilterOptions.today
            || this.filterQuery.weekFilterOptions.thisWeek
            || this.filterQuery.weekFilterOptions.nextWeek
            || this.filterQuery.weekFilterOptions.upcoming
            || this.filterQuery.weekFilterOptions.noDeadline
          )
        } else {
          return (
            this.filterQuery.noDepartment == 'accepted'
            || this.filterQuery.filterNoDueDate
            || this.filterQuery.query
            || this.filterQuery.status.length
            || this.filterQuery.publishStatus.length
            || this.filterQuery.filterByDateCreated
            || this.filterQuery.filterByDateCompleted
            || this.filterQuery.filterByPublishDate
            || this.filterQuery.coordinator.length 
            || this.filterQuery.tag.length
            || this.filterQuery.socialSeries.length
            || this.filterQuery.socialCampaign.length
            || this.filterQuery.department.length
            || this.filterQuery.sort
            || this.filterQuery.socialNetwork.length
            || this.filterQuery.project.length
        )
      }

    },
    createDeliverableType(deliverableType) {
      this.$store.dispatch("createDeliverableType", { deliverableType });
    },
    toggleStatusView() {
      if(this.isMobile()) {
        if(this.expandAll) {
          $('.deliverable-status-overview').hide();
          $('.deliverable-dates').css('padding-top', 0);
        } else {
          $('.deliverable-status-overview').show();
          $('.deliverable-dates').css('padding-top', '15px');
        }
      }
    },

    removeView(viewId) {
      this.$store.dispatch('removeView', viewId);
    },
    loadView() {
      // if(this.$router.currentRoute.name == 'dashboard') {
      //   // this.$store.commit('setDashboardDeliverableFilter', viewData);
      //   this.filterQuery = this.$store.getters.deliverableFilter;
      // } else if(this.$router.currentRoute.name == 'myWeek') {
      //   // this.$store.commit('setMyWeekDeliverableFilter', viewData);
      //   this.filterQuery = this.$store.getters.myWeekDeliverableFilter;
      // } else if(this.$router.currentRoute.name == 'mediaCallPage') {
      //   this.filterQuery = this.$store.getters.mediaCallFilter;
      // }

      this.filterQuery = this.$store.getters.socialMediaFilter;
    },
    saveView() {
      this.$bvModal.show("viewTitleModal");
    },
    setSort(sortType) {
      this.filterQuery["sort"] = sortType;
    },
    setQuery() {
      this.filterQuery.query = this.searchQuery;
      if(this.$router.currentRoute.name == 'globalSearch') {
        let searchQuery = this.searchQuery;
        let activeTab = this.GSDataType;
        this.$store.commit("setRecentSearch", { searchQuery, activeTab });
      }
    },

    onUpdateDateCreated() {
      this.filterQuery.filterByDateCreated = true;
      this.focusFilterBtn();
    },

    onUpdatePublishDate() {
      this.filterQuery.filterByPublishDate = true;
      this.focusFilterBtn();
    },


    onWhoSearch(input) {
      if (input != "" || this.initialContacts.length == 0) {
        this.isContactsLoading = true;
        if (typeof window.LIT !== "undefined") {
          clearTimeout(window.LIT);
        }
        window.LIT = setTimeout(() => {
          input = input == false ? "" : input;
          new Promise((resolve, reject) => {
            axios
              .get(
                process.env.MIX_API_BASE_URL + "activeContacts?q=" + encodeURI(input)
              )
              .then((resp) => {
                this.isContactsLoading = false;
                this.contacts = [];
                let x = 0;
                for (x = 0; x < resp.data.length; x++) {
                  resp.data[x]["name"] =
                    resp.data[x]["first_name"] +
                    " " +
                    resp.data[x]["last_name"];
                  this.contacts.push(resp.data[x]);
                }
                this.$store.commit("setInitialData", {
                  contacts: this.contacts,
                });
                resolve(this.contacts);
              })
              .catch((error) => {
                reject(error);
              });
          });
        }, 500);
      } else {
        this.contacts = this.initialContacts;
      }
    },
    onTagSearch(input) {
      this.isTagsLoading = true;
      if (typeof window.LIT1 !== "undefined") {
        clearTimeout(window.LIT1);
      }
      window.LIT1 = setTimeout(() => {
        if (input != "" || this.initialTags.length == 0) {
        input = input == false ? "" : input;
        new Promise((resolve, reject) => {
          axios
            .get(process.env.MIX_API_BASE_URL + "tags?q=" + encodeURI(input))
            .then((resp) => {
              this.isTagsLoading = false;
              this.tags = [];
              let x = 0;
              for (x = 0; x < resp.data.length; x++) {
                this.tags.push(resp.data[x]);
              }
              this.$store.commit("setInitialData", { tags: this.tags });
              resolve(this.tags);
            })
            .catch((error) => {
              reject(error);
            });
        });
        } else {
          this.isTagsLoading = false;
          this.tags = this.initialTags;
        }
      }, 500);
    },
    onSocialSeriesSearch(input) {
      this.isSocialSeriesLoading = true;
      if (typeof window.socialSeriesSearchDebounce !== "undefined") {
        clearTimeout(window.socialSeriesSearchDebounce);
      }
      window.socialSeriesSearchDebounce = setTimeout(() => {
        if (input != "" || this.allSocialSeries.length == 0) {
          input = input == false ? "" : input;
          new Promise((resolve, reject) => {
            axios
              .get(process.env.MIX_API_BASE_URL + "socialSeries?q=" + encodeURI(input))
              .then((resp) => {
                this.isSocialSeriesLoading = false;
                this.socialSeriesPlural = [];
                let x = 0;
                for (x = 0; x < resp.data.length; x++) {
                  this.socialSeriesPlural.push(resp.data[x]);
                }
                this.$store.commit("setInitialData", { socialSeriesPlural: this.socialSeriesPlural });
                resolve(this.socialSeriesPlural);
              })
              .catch((error) => {
                reject(error);
              });
          });
        } else {
          this.isSocialSeriesLoading = false;
          this.socialSeriesPlural = this.allSocialSeries;
        }
      }, 500);
    },
    onSocialCampaignSearch(input) {
      this.isSocialCampaignsLoading = true;
      if (typeof window.socialCampaignSearchDebounce !== "undefined") {
        clearTimeout(window.socialCampaignSearchDebounce);
      }
      window.socialCampaignSearchDebounce = setTimeout(() => {
        if (input != "" || this.allSocialCampaigns.length == 0) {
          input = input == false ? "" : input;
          new Promise((resolve, reject) => {
            axios
              .get(process.env.MIX_API_BASE_URL + "socialCampaigns?q=" + encodeURI(input))
              .then((resp) => {
                this.isSocialCampaignsLoading = false;
                this.socialCampaigns = [];
                let x = 0;
                for (x = 0; x < resp.data.length; x++) {
                  this.socialCampaigns.push(resp.data[x]);
                }
                this.$store.commit("setInitialData", { socialCampaigns: this.socialCampaigns });
                resolve(this.socialCampaigns);
              })
              .catch((error) => {
                reject(error);
              });
          });
        } else {
          this.isSocialCampaignsLoading = false;
          this.socialCampaigns = this.allSocialCampaigns;
        }
      }, 500);
    },
    onDepartmentSearchClose(input) {

    },
    onDepartmentSearch(input) {
      if (input != "" || this.initialDepartments.length == 0) {
        this.isDepartmentsLoading = true;
        if (typeof window.LIT2 !== "undefined") {
          clearTimeout(window.LIT2);
        }
        window.LIT2 = setTimeout(() => {
          input = input == false ? "" : input;
          new Promise((resolve, reject) => {
            axios
              .get(
                process.env.MIX_API_BASE_URL +
                  "departments?q=" +
                  encodeURI(input)
              )
              .then((resp) => {
                this.isDepartmentsLoading = false;
                this.departments = [];
                let x = 0;
                for (x = 0; x < resp.data.length; x++) {
                  this.departments.push(resp.data[x]);
                }
                this.$store.commit("setInitialData", {
                  departments: this.departments,
                });
                resolve(this.departments);
              })
              .catch((error) => {
                this.isTagsLoading = false;
                reject(error);
              });
          });
        }, 500);
      } else {
        this.departments = this.initialDepartments;
      }
    },
    resetFilter() {
      this.$root.$emit('resetView');
      this.filterQuery.filterNoDueDate = false;
      this.filterQuery.filterNoTaskDueDate = false;
      this.filterQuery.noDepartment = "not_accepted";
      this.filterQuery.query = null;
      this.searchQuery = "";
      $('.filter-rating .vue-star-rate ul li').each(function() {
        $(this).removeClass('active');
      })

      this.filterQuery.filterByDateCreated = false;
      this.filterQuery.dateCreatedRange = {
        startDate: new Date(),
        endDate: new Date(),
      };

      this.filterQuery.filterByPublishDate = false;
      this.filterQuery.datePublishRange = {
        startDate: new Date(),
        endDate: new Date(),
      };
      
      this.filterQuery.status = [];
      this.filterQuery.publishStatus = [];
      this.filterQuery.socialNetwork = [];
      this.filterQuery.tag = [];
      this.filterQuery.socialSeries = [];
      this.filterQuery.socialCampaign = [];
      this.filterQuery.sort = '';
      this.filterQuery.coordinator = [];
      this.filterQuery.department = [];
      this.filterQuery.project = [];
      this.filterQuery.socialSeries = [];
      this.filterQuery.socialCampaign = [];
    },
    outside() {
      this.showUserSelect = false;
    },
    createDeliverableDropdownClick(type) {
      this.deliverableType = type;
      this.createNewDeliverable();
    },
    createNewDeliverable() {

      let type = this.deliverableType.id;
      let that = this;
      this.$store.dispatch("createNewDeliverable", { type }).then(() => {
        // Accomodate the create deliverable change
        if(type == 'social_media'){
          that.$bvModal.show('editSocialModal');
        } else {
          that.$bvModal.show("editDeliverableModal");
          that.$nextTick(() => {
            $(".edit-deliverable-modal .deliverable-title").trigger("click");
          });
        }

        if (type == "social_media") {
          that.$store.dispatch("fetchSocialMediaDeliverablesGrouped");
        } else {
	        that.$store.dispatch("fetchDeliverables", this.$store.getters.currentPage);
	        that.$store.dispatch("fetchDeliverableCount");
	      }
      });
    },
    createNewSocialDeliverable() {
      let type = this.deliverableType.id;
      let that = this;
      this.$store.dispatch("createNewDeliverable", { type }).then(() => {
        that.$bvModal.show("editSocialModal");

        that.$store.dispatch("fetchDeliverables", this.$store.getters.currentPage);
        that.$store.dispatch("fetchDeliverableCount");
      });
    },
    setStatusFilter(status) {
      if (this.filterQuery.status.indexOf(status) != -1) {
        this.removeFilter(status);
      } else {
        this.filterQuery.status.push(status);
      }
    },
    setPublishStatusFilter(publishStatus) {
      if (this.filterQuery.publishStatus.indexOf(publishStatus) != -1) {
        this.removeFilter(publishStatus);
      } else {
        this.filterQuery.publishStatus.push(publishStatus);
      }
    },
    removeFilter(data) {
      if (typeof data != "undefined") {
        if (typeof data == "string") {
          if (
            this.$router.currentRoute.name == "globalSearch" &&
            data == "resetDepartStatus"
          ) {
            this.filterQuery.status = [];
          }
          if (
            this.$router.currentRoute.name == "globalSearch" &&
            data == "resetDepartTagSort"
          ) {
            this.filterQuery.sort = "";
          }
          if (
            this.$router.currentRoute.name != "globalSearch" &&
            data == "resetDeliverableSort"
          ) {
            this.filterQuery.sort = "";
          }
          if (data == "filterByDateCreated") {
            this.filterQuery.filterByDateCreated = false;
            this.filterQuery.dateCreatedRange.startDate = new Date();
            this.filterQuery.dateCreatedRange.endDate = new Date();
          }
          if (data == "filterByPublishDate") {
            this.filterQuery.filterByPublishDate = false;
            this.filterQuery.datePublishRange.startDate = new Date();
            this.filterQuery.datePublishRange.endDate = new Date();
          }

          if (data == "overdue") {
            this.filterQuery.weekFilterOptions.overdue = false;
          }
           if (data == "today") {
            this.filterQuery.weekFilterOptions.today = false;
          }
           if (data == "thisWeek") {
            this.filterQuery.weekFilterOptions.thisWeek = false;
          }
           if (data == "nextWeek") {
            this.filterQuery.weekFilterOptions.nextWeek = false;
          }
           if (data == "upcoming") {
            this.filterQuery.weekFilterOptions.upcoming = false;
          }
           if (data == "noDeadline") {
            this.filterQuery.weekFilterOptions.noDeadline = false;
          }

        } else {

	        if (typeof this.filterQuery.status != "undefined") {
	          this.filterQuery.status = this.filterQuery.status.filter((s) => {
	            return s.name != data.name;
	          });
	        }

          if (typeof this.filterQuery.publishStatus != "undefined") {
            this.filterQuery.publishStatus = this.filterQuery.publishStatus.filter((s) => {
              return s.name != data.name;
            });
          }

          if (typeof this.filterQuery.socialNetwork != "undefined") {
            this.filterQuery.socialNetwork = this.filterQuery.socialNetwork.filter((s) => {
              return s.id != data.id;
            });
          }

	        if (typeof this.filterQuery.coordinator != "undefined") {
	          this.filterQuery.coordinator = this.filterQuery.coordinator.filter(
	            (s) => {
	              return s.name != data.name;
	            }
	          );
	        }

	        if (typeof this.filterQuery.tag != "undefined") {
	          this.filterQuery.tag = this.filterQuery.tag.filter((s) => {
	            return s.name != data.name;
	          });
	        }

          if (typeof this.filterQuery.socialSeries != "undefined") {
            this.filterQuery.socialSeries = this.filterQuery.socialSeries.filter((s) => {
              return s.name != data.name;
            });
          }

          if (typeof this.filterQuery.socialCampaign != "undefined") {
            this.filterQuery.socialCampaign = this.filterQuery.socialCampaign.filter((s) => {
              return s.name != data.name;
            });
          }

	        if (typeof this.filterQuery.department != "undefined") {
	          this.filterQuery.department = this.filterQuery.department.filter(
	            (s) => {
	              return s.name != data.name;
	            }
	          );
	         }

          if (typeof this.filterQuery.project != "undefined") {
            this.filterQuery.project = this.filterQuery.project.filter(
              (s) => {
                return s.id != data.id;
              }
            );
          }
        }
      } else {
        // TODO:  Check if a filter can be anything other than a string or object.
      }
    },
    triggerSearch() {
      if (this.$refs.searchQuery.value != "") {
        if (this.$router.currentRoute.name == "globalSearch") {
          this.setDataLoading(true);
          this.$store.dispatch("globalSearch").then(() => {
            this.setDataLoading(false);
          });
        } else {
          this.setDataLoading(true);
          this.$store.dispatch("fetchDeliverables").then(() => {
            this.setDataLoading(false);
          });
        }
      }
    },
    focusFilterBtn() {
      if (typeof this.$refs.filterBoxBtn != "undefined") {
        this.$refs.filterBoxBtn.focus();
      } else if (typeof this.$refs.GSCreatedDate != "undefined") {
        this.GSCreatedDatePopover = false;
      }
    },

    async initDeliverableTypes() {
      await this.getDeliverableTypes();
      this.deliverableType = this.deliverableTypes[0];
    },
    async initSocialSeries() {
      await this.fetchSocialSeries();
      this.socialSeriesPlural = this.allSocialSeries;
    },
    async initSocialCampaigns() {
      await this.fetchSocialCampaigns();
      this.socialCampaigns = this.allSocialCampaigns;
    },

    changeCalendarMode(mode) {
      this.calendarMode = mode;
      this.filterQuery.dataSetType = mode;
      (mode != 'projects') ? this.getCalendarData(mode) : false;
    },
    checkCalendarMode(modes) {
      if (!this.isCalendarView) {
        return true;
      } else {
        return modes.includes(this.calendarMode);
      }
    }
  },
  watch: {
    filterQuery: {
      handler: async function (val, oldVal) {
        this.$root.$emit('showUpdateViewText', {currentFilter: val, isFilterActive: this.isFilterActive()});
        this.filterQuery["myWeek"] = this.myWeek;
        this.$store.commit("setSocialMediaFilter", this.filterQuery);
        if (router.currentRoute.name == "globalSearch") {
          this.setDataLoading(true);
          this.$store.dispatch("globalSearch").then(() => {
            this.setDataLoading(false);
          });
        } if (router.currentRoute.name == "calendar") {
          this.setDataLoading(true);
          this.$store.dispatch("getCalendarData", this.calendarMode).then(() => {
            this.setDataLoading(false);
          });
        } else if (router.currentRoute.name == "socialMediaSchedule") {
          this.setDataLoading(true);
          this.$store.dispatch("fetchCalendarDeliverables").then(() => {
            this.setDataLoading(false);
          });
        } else if (router.currentRoute.name == "socialMediaGrouped" || router.currentRoute.name == "socialMedia") {
          this.setDataLoading(true);
          // await this.$store.dispatch("fetchDeliverableCount");
          this.$store.dispatch("fetchSocialMediaDeliverablesGrouped").then(() => {
            this.setDataLoading(false);
          });
        } else {
          this.setDataLoading(true);
          await this.$store.dispatch("fetchDeliverableCount");
          this.$store.dispatch("fetchDeliverables").then(() => {
            this.setDataLoading(false);
          });
        }
        if (
          !this.filterQuery.query &&
          !this.filterQuery.filterByDateCreated &&
          !this.filterQuery.filterByPublishDate &&
          !this.filterQuery.status.length &&
          !this.filterQuery.publishStatus.length &&
          !this.filterQuery.socialNetwork.length &&
          !this.filterQuery.coordinator.length &&
          !this.filterQuery.tag.length &&
          !this.filterQuery.socialSeries.length &&
          !this.filterQuery.socialCampaign.length &&
          !this.filterQuery.department.length &&
          !this.filterQuery.project.length &&
          this.filterQuery.noDepartment != "accepted" &&
          !this.filterQuery.filterNoTaskDueDate &&
          !this.filterQuery.sort
        ) {
          $(".deliverable-listing").removeClass("hasFilter");
          $(".global-search-data-wrapper").removeClass("hasFilter");
        } else {
          $(".deliverable-listing").addClass("hasFilter");
          $(".global-search-data-wrapper").addClass("hasFilter");
        }
      },
      deep: true,
    },
    allSocialCampaigns: {
    	handler: async function (val, oldVal) {
    		this.socialCampaigns = val;
    	}
    },
    allSocialSeries: {
    	handler: async function (val, oldVal) {
    		this.socialSeriesPlural = val;
    	}
    },
    $route (to, from){
      if(typeof this.$route.params.socialGroupBy != 'undefined') {
        this.setSocialGroupBy(to.params.socialGroupBy);
      }
    },
    expandAll: {
      handler: function (val, oldVal) {
        this.$emit("collapseToggleUpdated", val);
      },
    },
    calendarMode: {
      handler: function (val, oldVal) {
        if (val == 'projects') {

          // Tag
          this.filterQuery.tag.forEach(tag => {
            this.removeFilter(tag);
          });

          this.filterQuery.socialSeries.forEach(socialSeries => {
            this.removeFilter(socialSeries);
          });

          this.filterQuery.socialCampaign.forEach(socialCampaigns => {
            this.removeFilter(socialCampaigns);
          });

          // Project
          this.filterQuery.project.forEach(project => {
            this.removeFilter(project);
          });

        }
      },
    }
  },
};
</script>

<style scoped>


</style>
